/** @file SHEET_FACINGS: the body facings a sheet is drawn for (front, left, back, right) and their labels. */

/** Degrees clockwise from south (0 = toward the viewer, 90 = turned to face screen-left) and a short label. */
export const SHEET_FACINGS: readonly { deg: number; label: string }[] = [
  { deg: 0, label: 'front' }, { deg: 90, label: 'left' }, { deg: 180, label: 'back' }, { deg: 270, label: 'right' },
];
